import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetGettingStartedNotificationsParams {
  checkUserPrefs: boolean;
}

export interface IGetGettingStartedNotificationsResult extends IResult {
  contentUrl: string;
}

export class GetGettingStartedNotificationsRequest
    extends Request<IGetGettingStartedNotificationsParams, IGetGettingStartedNotificationsResult> {

  constructor(params: IGetGettingStartedNotificationsParams) {
    super('getGettingStartedNotifications', params);
  }

}

export interface ISetSuppressGettingStartedNotificationParams {
  suppressGettingStartedNotifications: boolean;
}

export class SetSuppressGettingStartedNotification extends Request<ISetSuppressGettingStartedNotificationParams, IResult> {
  constructor(params: ISetSuppressGettingStartedNotificationParams) {
    super('setSuppressGettingStartedNotifications', params);
  }
}
